<a [routerLink]="url" class="back-link">
  <img src="/assets/icons/chevron-circle.svg" alt="back" />
  <span>{{ text }}</span>
</a>
